import { render } from "./CategoriesRow.vue?vue&type=template&id=30a0c05d"
import script from "./CategoriesRow.vue?vue&type=script&lang=js"
export * from "./CategoriesRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__